import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import tmdbApi from "../../api/tmdbApi";
import calenderIcon from "../../assets/images/blank-notepad--content-notes-book-notepad-notebook.svg";
import circleClock from "../../assets/images/circle-clock--clock-loading-measure-time-circle.svg";
// import doctorTab from "../../assets/images/doctor-tab.svg";
import slotIcon from "../../assets/images/slots-icon.svg";
import SweetAlert from "react-bootstrap-sweetalert";
import quizThumb from '../../assets/images/quiz-default.jpg';
import eqa from '../../assets/images/eqa-img.jpg';
import spotIcon from '../../assets/images/slot-icon.svg';
import sessionbg from '../../assets/images/session-bg.svg';
import calendar from '../../assets/images/icons/calendar.svg';
import clock from '../../assets/images/icons/clock.svg';
import livecpc from '../../assets/images/live-cpc.svg';
import clockIcon from '../../assets/images/clock-icon.svg';
import noEvent from '../../assets/images/no-events-img.svg';
import AwaitingForSession from "./AwatingSession";
import axios from "axios";
import DescCPCBlock from "./descCPCBlock";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';



const CPCBlock = ({ img, timer, table }) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const navigate = useNavigate();
    const [quizInfo, setQuizInfo] = useState(null)
    const [nextSession, setNextSession] = useState(false);

    const [isEnabled, setIsEnabled] = useState(false);
    const [error, setError] = useState("Pre-CPC Quiz of the month");
    const [successMsgDisplay, setSuccessDisplay] = useState(false);
    const [successMsg, setSuccessMsg] = useState('');

    const [completedResult, setCompletedResult] = useState([])

    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [timeZone, setTimeZone] = useState("Asia/Kolkata")
    const userAgent = async () => {
        try {
            const response = await axios.get("https://d4nv8o5tzs3mt.cloudfront.net/");
            const locData = response?.data;

            // Store full data if needed later
            localStorage.setItem("loc", JSON.stringify(locData));

            // Extract timezone from CloudFront headers
            const viewerTimeZone = locData?.headers?.["cloudfront-viewer-time-zone"];
            const timeZoneTmp =
                Array.isArray(viewerTimeZone) && viewerTimeZone[0]?.value
                    ? viewerTimeZone[0].value
                    : "Asia/Kolkata"; // default fallback

            setTimeZone(timeZoneTmp);
        } catch (error) {
            console.error("Error fetching timezone:", error);
            setTimeZone("Asia/Kolkata"); // fallback in case of error
        }
    };




    function isScheduleTimeCrossed() {
        const scheduleDate = quizInfo?.meetingDate;
        const scheduleEndTime = quizInfo?.meetingEndTime;

        if (!scheduleDate || !scheduleEndTime) return;

        const datePart = scheduleDate.split("T")[0]; // "YYYY-MM-DD"
        const dateTimeStr = `${datePart}T${scheduleEndTime}`; // "YYYY-MM-DDTHH:mm"
        const zone = timeZone || "Asia/Kolkata";

        const endTime = dayjs.tz(dateTimeStr, zone);
        const now = dayjs().tz(zone);

        setNextSession(now.isAfter(endTime));
    }

    useEffect(() => {

        getCpcInfo()
        userAgent()

    }, []);

    useEffect(() => {
        if (quizInfo) {
            let interval;
            isScheduleTimeCrossed();
            interval = setInterval(isScheduleTimeCrossed, 1000);
            return () => clearInterval(interval);
        }
    }, [quizInfo])



    let token = localStorage.getItem("token")

    const getCpcInfo = async () => {
        console.log('----geecpcblcok')
        const response = await tmdbApi.cpcInfo("ACTIVE");
        // debugger
        if (response?.result?.length > 0) {

            if (!response.result[0]?.reserved) {
                setError("Please Reserve your spot")
            }
            if (response.result[0]?.participated && response.result[0]?.reserved) {
                setError("You have already participated")
            }


            setQuizInfo(response?.result[0])
        }
    }

    const refresh = () => {
        setSuccessDisplay(false);
        if (['this spot is already reserved', 'spot added successfully'].includes(successMsg?.toLowerCase())) {
            setError("Pre-CPC Quiz of the month");
        } else {
            setError(successMsg);
        }
        getCpcInfo();


    }

    useEffect(() => {
        let interval;
        if (quizInfo) {
            winnerInfo();

            // const checkTime = () => {
            //     if (
            //         !quizInfo?.scheduleDate ||
            //         !quizInfo?.scheduleStartTime ||
            //         !quizInfo?.scheduleEndTime
            //     ) return;

            //     let loc = JSON.parse(localStorage.getItem("loc"));
            //     let userTimeZone = "UTC"; // fallback

            //     if (loc?.headers?.['cloudfront-viewer-time-zone']?.length > 0) {
            //         userTimeZone = loc.headers['cloudfront-viewer-time-zone'][0].value;
            //     }
            //     const datePart = quizInfo.scheduleDate ? quizInfo.scheduleDate.split("T")[0] : null;
            //     // const datePart = quizInfo.scheduleDate.split("T")[0]; // "YYYY-MM-DD"
            //     const [year, month, day] = datePart.split("-").map(Number);

            //     const [startHour, startMinute] = quizInfo.scheduleStartTime.split(":").map(Number);
            //     const [endHour, endMinute] = quizInfo.scheduleEndTime.split(":").map(Number);

            //     // Build UTC date adjusted for IST
            //     const toDateInIST = (h, m) => new Date(Date.UTC(year, month - 1, day, h - 5, m - 30));

            //     const startTime = toDateInIST(startHour, startMinute);
            //     const endTime = toDateInIST(endHour, endMinute);
            //     const now = new Date();

            //     console.log("Start:", startTime, "Now:", now, "End:", endTime, now.getMilliseconds() >= startTime.getMilliseconds() && now <= endTime.getMilliseconds());

            //     setIsEnabled(now.getTime() >= startTime.getTime() && now.getTime() <= endTime.getTime());



            //     const finalDate = new Date(quizInfo?.scheduleDate);
            //     finalDate.setUTCHours(hours);
            //     finalDate.setUTCMinutes(minutes);
            //     finalDate.setUTCSeconds(0);
            //     finalDate.setUTCMilliseconds(0);


            //     const timeDifference = finalDate - now;

            //     if (timeDifference <= 0) {
            //         clearInterval(interval);
            //         setDays(0);
            //         setHours(0);
            //         setMinutes(0);
            //         setSeconds(0);
            //         return;
            //     }

            //     setDays(Math.floor(timeDifference / (1000 * 60 * 60 * 24)));
            //     setHours(Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
            //     setMinutes(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)));
            //     setSeconds(Math.floor((timeDifference % (1000 * 60)) / 1000));



            // };
            const checkTime = () => {
                if (
                    !quizInfo?.meetingDate ||
                    !quizInfo?.meetingStartTime ||
                    !quizInfo?.meetingEndTime
                ) return;

                let loc = JSON.parse(localStorage.getItem("loc"));
                let userTimeZone = "UTC"; // fallback

                if (loc?.headers?.['cloudfront-viewer-time-zone']?.length > 0) {
                    userTimeZone = loc.headers['cloudfront-viewer-time-zone'][0].value;
                }
                const datePart = quizInfo.meetingDate
                // const datePart = quizInfo.scheduleDate.split("T")[0]; // "YYYY-MM-DD"
                const [year, month, day] = datePart.split("-").map(Number);

                const [startHour, startMinute] = quizInfo.meetingStartTime.split(":").map(Number);
                const [endHour, endMinute] = quizInfo.meetingEndTime.split(":").map(Number);

                // Build UTC date adjusted for IST
                const toDateInIST = (h, m) => new Date(Date.UTC(year, month - 1, day, h - 5, m - 30));

                const startTime = toDateInIST(startHour, startMinute);
                const endTime = toDateInIST(endHour, endMinute);
                const now = new Date();

                // console.log("Start:", startTime, "Now:", now, "End:", endTime, now.getMilliseconds() >= startTime.getMilliseconds() && now <= endTime.getMilliseconds());

                setIsEnabled(now.getTime() >= startTime.getTime() && now.getTime() <= endTime.getTime());


                const finalDate = dayjs(`${quizInfo.meetingDate.split("T")[0]}T${quizInfo.meetingStartTime}`)

                // finalDate.setUTCHours(hours);
                // finalDate.setUTCMinutes(minutes);
                // finalDate.setUTCSeconds(0);
                // finalDate.setUTCMilliseconds(0);


                const timeDifference = finalDate - now;

                if (timeDifference <= 0) {
                    clearInterval(interval);
                    setDays(0);
                    setHours(0);
                    setMinutes(0);
                    setSeconds(0);
                    return;
                }

                setDays(Math.floor(timeDifference / (1000 * 60 * 60 * 24)));
                setHours(Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
                setMinutes(Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60)));
                setSeconds(Math.floor((timeDifference % (1000 * 60)) / 1000));



            };
            checkTime(); // Initial call
            interval = setInterval(checkTime, 1000); // Repeat every 30 sec

            return () => clearInterval(interval); // Cleanup
        }
    }, [quizInfo]);


    const winnerInfo = async () => {

        const response = await tmdbApi.studentCompletedQuiz();
        if (response?.result) {
            setCompletedResult(response?.result)
        }
    }
    const handleViewQuiz = (id) => navigate(`/cpc-result/${id}`);


    return (
        <>

            <div className="cpc-data-table">


                {
                    quizInfo && !nextSession ? 
                    <div className="session_block col-lg-12">
                        {!table && timer && <div className="session-image-box ">
                            <img src={livecpc} className="live_cpc" width="44" />
                            <div className="countdown" id="countdown">
                                <div><span id="days">{days}</span>DAYS</div>
                                <div><span id="hours">{hours}</span>HOURS</div>
                                <div><span id="minutes">{minutes}</span>MINUTES</div>
                                <div><span id="seconds">{seconds}</span>SECONDS</div>
                            </div>
                        </div>
                        }
                        {!timer && <div className="col-lg-4 col-md-12 p-0 cpc-img-txt">
                            <img src={img} alt="Quiz Cover" className="cpc-img img-fluid object-fit-cover" />
                            <div className="fw-bold note mt-2 pb-5 sub-note text-start">
                                "Subscription teaser: “Unlock recordings for INR 10,000/USD 120 annually.
                                <p className="text-start">No registration fee. No strings. Just learning."</p>
                                 {/* <p className="text-start">Note: Please note that recording of CPC only available for people who participate and submit the quiz.</p> */}
                            </div>

                        </div>}


                        <DescCPCBlock quizInfo={quizInfo} getCpcInfo={getCpcInfo} timer={timer} />

    
                    </div> :
                     <AwaitingForSession timer={timer} />
                }




                {table && completedResult && completedResult?.length > 0 &&
                    <div className="container" id="cpcTable">
                        <div className="">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h4 className="card-title">Winner's</h4>
                                        {/* <button className="reset-quiz-btn ps-3 pe-3">View All</button> */}
                                    </div>
                                    <div className="quiz-table-wrapper">
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                            <table className="table align-middle table-nowrap mb-0" id="quiz-table-cpc">
                                                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th className="align-middle scno-col">ID</th>
                                                        <th className="align-middle name-col">PRE-CPC TITLE</th>
                                                        <th className="align-middle date-col">Date</th>
                                                        <th className="align-middle marks-col">Score</th>
                                                        <th className="align-middle marks-col">Percentile</th>

                                                        <th className="align-middle marks-col">Action</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {completedResult && completedResult.length > 0 && completedResult.map(function (item, i) {
                                                        return (
                                                            <tr key={i}>
                                                                <td className="scno-col">
                                                                    <a href="javascript:void(0);" className="text-body">{i + 1}</a>
                                                                </td>
                                                                <td className="name-col">{item?.title}</td>
                                                                <td className="date-col">{item?.formattedDate}</td>
                                                                <td className="marks-col">  <div className="winner">

                                                                    {item?.winner && <span className="material-symbols-outlined icon">
                                                                        trophy
                                                                    </span>}

                                                                    {item?.score}
                                                                </div>
                                                                </td>
                                                                <td className="date-col">{item?.percentileRank}</td>
                                                                <td className="marks-col d-flex justify-content-end"><div className="upcoming-icons" style={{ display: 'flex' }}>
                                                                    <a onClick={e => handleViewQuiz(item.cpcid)} className='text-success action-button'><i className="mdi mdi-eye font-size-18"></i></a>

                                                                    <a className='text-success view-button'><i
                                                                        className="mdi mdi-eye font-size-16"></i>  </a>

                                                                </div></td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>


                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>}




                <SweetAlert
                    show={successMsgDisplay}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={successMsg}
                    onConfirm={e => refresh()}
                    id="error-alert"
                ></SweetAlert>

            </div>


        </>)

}
export default CPCBlock;
